import { render, staticRenderFns } from "./EmergingWorkDetails.vue?vue&type=template&id=429af65d&scoped=true&"
import script from "./EmergingWorkDetails.vue?vue&type=script&lang=js&"
export * from "./EmergingWorkDetails.vue?vue&type=script&lang=js&"
import style0 from "./EmergingWorkDetails.vue?vue&type=style&index=0&id=429af65d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429af65d",
  null
  
)

export default component.exports